module.exports = {"notification.message":"Wix.com은 최상의 경험을 제공하기 위해 쿠키를 사용합니다.","notification.got.it":"확인","notification.more.info":"자세히 보기","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_ko.json
// module id = 51
// module chunks = 0